module.exports = __webpack_public_path__ + "static/media/sared.a015e30c.webp";